// 统一请求路径前缀在libs/axios.js中修改
import {postJsonRequest,getRequest, postFormRequest, postRequest, putRequest, deleteRequest, getRequestWithNoToken, postFZRequest } from '@/libs/axios';


// 导入Excel
export const excelImport = (params) => {
    return postFormRequest('/incomeAnalyse/importIncomeAnalyse',params)
}

// 版权方-数字一览
export const copyrightTotalGetTotal = (params) => {
    return getRequest('/copyrightTotal/getCopyrightTotal', params)
}

// 版权-获取全部数据
export const copyrightGetAll = (params) => {
    return getRequest('/videoclip/copyright/getAll', params)
}

//收益分析->版权方名称下拉列表接口
export const getAllIncomeAnalyse = (params) => {
    return getRequest('/incomeAnalyse/getCopyrightVendorList', params)
}

//收益分析->版权名称下拉列表接接kou
export const getAllAnalyseCopyrightList = (params) => {
    return getRequest('/incomeAnalyse/getCopyrightList', params)
}

// 侵权-数据一览
export const getMonitorTotal = (params) => {
    return getRequest('/monitorTotal/getMonitorTotal', params)
}

//侵权分析->版权方名称下拉列表接口
export const getAllMonitorAnalyse = (params) => {
    return getRequest('/monitorAnalyse/getCopyrightVendorList', params)
}

//侵权分析->版权名称下拉列表接口
export const getAllMonitoreCopyrightList = (params) => {
    return getRequest('/monitorAnalyse/getCopyrightList', params)
}

//GET /hatch/videoclip/copyright/getByPage 分页获取我的作品
export const getMyWorkList = (params) => {
    return getRequest('/videoclip/copyright/getCopyrightVendorByPage', params)
}

//GET /hatch/videoclip/copyright/getCopyrightStatus 动态判断版权状态
export const getCopyrightStatus = (params) => {
    return getRequest('/videoclip/copyright/getCopyrightStatus', params)
}

//GET /hatch/videoclip/copyright/getCopyrightDetails 通过id获取版权详情
export const getCopyrightDetails = (params) => {
    return getRequest('/videoclip/copyright/getCopyrightDetails', params)
}

//GET /hatch/videoclip/copyright/get/{id} 通过id获取
export const getWorksDetails = (params) => {
    return getRequest(`/videoclip/copyright/get/${params}`, )
}

//DELETE /hatch/videoclip/copyright/delByIds/{ids} 批量通过id删除
export const delWorkByIds = (params) => {
    return deleteRequest(`/videoclip/copyright/deleteIds/${params}`, )
}

//POST /hatch/videoclip/monitor/monitorCopyrightTask/insertFrontBatch 批量添加任务 请求侵权检测
export const insertFrontBatch = (params) => {
    return postRequest('/videoclip/monitor/monitorCopyrightTask/insertFrontBatch',params)
}
///dictData/getByType/copyright_category
export const getCategory = (params) => {
    return getRequest(`/dictData/getByType/copyright_category`, params)
}

export const getCountryList = (params) => {
    return getRequest(`/videoclip/copyright/getCountryList`, params)
}
///dictData/getByType/copyright_theme
export const getTheme = (params) => {
    return getRequest(`/dictData/getByType/copyright_theme`, params)
}

//POST /hatch/videoclip/copyright/saveCopyright 添加单个版权
export const saveCopyright = (params) => {
    return postFormRequest(`/videoclip/copyright/saveCopyright`, params)
}

//POST /hatch/hwFile/uplaodImg 上传单个图片

export const uplaodImg = (params) => {
    return postFormRequest(`/hwFile/uplaodImg`, params)
}

//GET /hatch/videoclip/currentUser/getCurrentUser 获取当前用户
export const getCurrentUser = (params) => {
    return getRequest(`/videoclip/currentUser/getCurrentUser`,params)
}

//POST /hatch/videoclip/copyrightAuthorize/vendor/page 个人中心版权方-->授权管理分页获取
export const getCopyrightAuthorize = (params) => {
    return postRequest(`/videoclip/copyrightAuthorize/vendor/page${params}`,)
}

///POST /hatch/videoclip/copyrightAuthorize/status/update 授权审核接口
export const postAuthorizeStatus = (params) => {
    return postRequest(`/videoclip/copyrightAuthorize/status/update${params}`,)
}

//GET /hatch/videoclip/copyrightAuthorize/details/get 授权管理-->查看详情
export const getAuthorizeDetail = (params) => {
    return getRequest(`/videoclip/copyrightAuthorize/details/get/${params}`,)
}

///POST /hatch/wemedia/ability/find查找我的能力
export const findAbility = (params) => {
    return postRequest(`/wemedia/ability/find`,params)
}

//POST /hatch/videoclip/copyrightAuthorize/details/copyright/page 授权管理-->查看详情-->版权详情分页获取
export const getCopyrightPage = (params) => {
    return postRequest(`/videoclip/copyrightAuthorize/details/copyright/page${params}`,)
}

//GET /hatch/firstPage/getCopyrightList 首页版权列表
export const getCopyrightListIndex = (params) => {
    return getRequest(`/firstPage/getCopyrightList`,)
}


// WEBPACK FOOTER //
// ./src/api/copyright.js